<template>
  <div class="widget">
    <div class="widget__head">
      <h3 class="widget__title">Способы доступа к 1С</h3>
    </div>
    <div v-loading="isEmpty(links)" class="widget__body pb-0">
      <div class="row">
        <div class="col-md-6 mb-24">
          <a class="link icon-text-align mb-4" @click="downloadRDP('getRdpSh', 'remote-access')">
            <span class="icon icon-primary mr-8" v-html="require('@/assets/img/icons/download.svg')" />
            RDP доступ
          </a>
          <p class="text-muted pl-24">Скачайте ярлык для запуска 1С в режиме “Удаленного рабочего стола”</p>
        </div>
        <div class="col-md-6 mb-24">
          <a class="link icon-text-align mb-4" @click="downloadRDP('getRappSh', 'remote-access-enterprise')">
            <span class="icon icon-primary mr-8" v-html="require('@/assets/img/icons/download.svg')" />
            RDP доступ к 1С Предприятию
          </a>
          <p class="text-muted pl-24">Запуск  1С Предприятие по технологии RDP, через через толстый клиент</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mb-24">
          <router-link :to="{ name: 'databases' }" class="link icon-text-align mb-4">
            <span class="icon icon-primary mr-8" v-html="require('@/assets/img/icons/link.svg')" />
            Ссылка на базу 1С
          </router-link>
          <p class="text-muted pl-24">Открываете ссылку в браузере, указываете логин/пароль и работаете в 1С. Необходимо заказать через Вашего менеджера.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { isEmpty } from 'lodash-es'

  export default {
    data() {
      return {
        polling: null
      }
    },

    computed: {
      links() {
        return this.$store.state.user.accessLinks || {}
      }
    },
    // TODO: для каждого инстанса этого компонента запустится свой интервал. Нужен общий интервал в сторе? Где тогда его чистить?
    created() {
      this.$store.dispatch('fetchAccessLinks')

      this.polling = setInterval(() => {
        if (isEmpty(this.links)) {
          this.$store.dispatch('fetchAccessLinks')
        } else {
          clearInterval(this.polling)
        }
      }, 60000)
    },

    beforeDestroy () {
      clearInterval(this.polling)
    },

    methods: {
      isEmpty,
      downloadRDP(method, fileName) {
        this.$http.getFile(method, { fileName, type: 'rdp' })
      }
    }
  }
</script>
